import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { filter } from 'rxjs';
import { ChapterViewState } from 'src/app/components/members/chapter-view/chapter-view.model';
import { Course } from 'src/app/models/course.model';
import { CourseState } from '../courses/courses.reducer';
import { getCourseSelected, getSelectedCourseState, isCourseNotSelected } from '../courses/courses.selector';

@Directive({
  selector: '[routeTransformer]'
})
export class RouteTransformerDirective {

  courseSelected$ = this.courseStore.pipe(select(getSelectedCourseState), filter(val => val !== null && val !== undefined));
  courseNotSelected$ = this.courseStore.pipe(select(isCourseNotSelected), filter(val => val))
  currentCourse: CourseState;
  currentChapterId: string;
  

  constructor(private el: ElementRef, private router: Router,
    private courseStore: Store<CourseState>,
    private chapterViewStore: Store<ChapterViewState>,
  ) {
    this.courseSelected$.subscribe(val => this.currentCourse = val);
    this.courseNotSelected$.subscribe(val => this.currentCourse = undefined);
    this.chapterViewStore.subscribe(val => this.currentChapterId = val.chapterId);
  }

  @HostListener('click', ['$event'])
  public onClick(event) {
    let link: string = null;
    if (event.target.tagName !== 'A') {
      const parent = event.target.closest('a[href*="courses/' + this.currentCourse.course.id + '/chapters"]');
      if (!parent) {
        return;
      }

      link = parent.href;
    } else {
      link = event.target.getAttribute('href');
    }

    if (link && !link.startsWith("http") && this.isPathInSection(link, 'courses/' + this.currentCourse.course.id + '/chapters')) {
      this.router.navigate([link]);
      event.preventDefault();
    } else if (link && this.isPathInSection(link, 'courses/' + this.currentCourse.course.id + '/chapters')) {
      this.router.navigate([new URL(link).pathname]);
      event.preventDefault();
    }
  }

  private isPathInSection(url: string, section: string): boolean {
    const urlPath = new URL(url, window.location.origin).pathname;
    return urlPath.includes(section);
  }

};